import { render, staticRenderFns } from "./BarCharts.vue?vue&type=template&id=1dca8b0a&scoped=true&"
import script from "./BarCharts.vue?vue&type=script&lang=js&"
export * from "./BarCharts.vue?vue&type=script&lang=js&"
import style0 from "./BarCharts.vue?vue&type=style&index=0&id=1dca8b0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca8b0a",
  null
  
)

export default component.exports